import { combineReducers } from "redux";

import { activitiesReducer as activities } from "./activity";
import { activityUserStatesReducer as activityUserStates } from "./activity_user_state";
import { documentActivitiesReducer as documentActivities } from "./document_activity";
import { documentActivityAmendmentsReducer as documentActivityAmendments } from "./document_activity_amendment";
import { documentSetDocumentActivitiesReducer as documentSetDocumentActivities } from "./document_set_document_activity";
import { documentSetDocumentRelationsReducer as documentSetDocumentRelations } from "./document_set_document_relation";
import { documentSetDocumentStatesReducer as documentSetDocumentStates } from "./document_set_document_state";
import { documentsReducer as documents } from "./document";
import { documentUserStatesReducer as documentUserStates } from "./document_user_state";
import { versionsReducer as versions } from "./version";

import { listsReducer as lists } from "./list";

export default combineReducers({
  activities,
  activityUserStates,
  documentActivities,
  documentActivityAmendments,
  documents,
  documentSetDocumentActivities,
  documentSetDocumentRelations,
  documentSetDocumentStates,
  documentUserStates,
  versions,

  lists,
});
